import Swiper, { Navigation, FreeMode, Thumbs } from "swiper";

export default class ComponentTituloSubtituloSliderImagens {
    constructor() {

        this.navigationPrev = document.querySelector(".slider-button-prev--component-titulo_subtitulo_slider_imagens")
        this.navigationNext = document.querySelector(".slider-button-next--component-titulo_subtitulo_slider_imagens")
        
        this.sliderGalerys = document.querySelectorAll(".swiper--component-titulo_subtitulo_slider_imagens")
        this.sliderGalerysThumbs = document.querySelectorAll(".swiper--component-titulo_subtitulo_slider_imagens-thumbs")

        this.ready();
    }

    ready() {

        let swiperGalleryThumbs = []
        if(this.sliderGalerysThumbs.length > 0 ) {
            this.sliderGalerysThumbs.forEach((sliderThumbs, index) => {
                
                // //Inicia slider de thumbs
                swiperGalleryThumbs[index] = new Swiper(sliderThumbs, {
                    modules: [FreeMode],
                    spaceBetween: 10,
                    slidesPerView: 4,
                    freeMode: true,
                    grabCursor: true,
                    watchSlidesProgress: true,
                })

            })
        }
        
        if(this.sliderGalerys.length > 0 ) {
            this.sliderGalerys.forEach((slider, index) => {

                //Inicia slider de fotos
                const swiperGallery = new Swiper(slider, {
                    modules: [Navigation, Thumbs],
                    grabCursor: true,
                    allowTouchMove: true,
                    slidesPerView: 1,
                    navigation: {
                        nextEl: this.navigationNext,
                        prevEl: this.navigationPrev
                    },
                    thumbs: {
                        swiper: swiperGalleryThumbs[index],
                    },
                })

            })
        }

    }
}